const STRINGS = {
  select: "Select",
  selectAll: selectedCount => `Select All Checkbox, ${selectedCount} items selected`,
  checkboxAriaLabelSelect: null,
  collapse: "Collapse",
  collapseAll: rowsCount => `Collapse All ${rowsCount} rows`,
  collapseAllRowsAnnouncement: rowsCount => `all ${rowsCount} rows, collapsed`,
  expand: "Expand",
  expandAll: rowsCount => `Expand All ${rowsCount} rows`,
  expandAllRowsAnnouncement: rowsCount => `all ${rowsCount} rows, expanded`,
  rowExpandButtonLabel: (itemKey, item) => {
    const itemNumber = `Item ${item.itemNumber}`;
    const expandBtnLabel = `${item.expanded ? "collapse" : "expand"} more about ${itemKey}`;
    return item.itemNumber ? `${itemNumber} ${expandBtnLabel}` : expandBtnLabel;
  },
  collapsedRowAnnouncement: itemKey => `more about ${itemKey}, collapsed`,
  expandedRowAnnouncement: itemKey => `more about ${itemKey}, expanded`,
  item: "Item",
  noResults: "No data available.",
  noResultsFindBy: "No results. Change your criteria and try again."
};
export default STRINGS;